import React, { useState, useEffect } from 'react';
import HeaderNotification from '../../components/header-notification-menu/header-notification-menu';
import { useModal } from '@ampol/design-system';
import Notification from '../../components/notification-content/notification-content';
import { useSelector } from 'react-redux';
import { trackCustomEvent } from 'utilities/app-insights';

/**
 * Header notification menu wrapper component
 * @returns JSX Element
 */
const HeaderNotificationMenuWrapper = ({ hasTopBar, isSearchActive, isImpersonating, isMaintenanceActive, setIsNotificationModalOpen }) => {
  const [notificationItem, setNotificationItem] = useState(null);
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);

  useEffect(() => {
    if (notificationItem) {
      notificationModal.open();
      setIsNotificationModalOpen && setIsNotificationModalOpen(true);
    }
  }, [notificationItem]);

  const onSelectNotificationItem = (item) => {
    trackCustomEvent('View Notification Details', loggedInUser, undefined, 'Clicked on a notification to view notification details.');
    setNotificationItem(item);
  };

  const notificationModal = useModal({
    id: 'notification-modal',
    title: 'Notification',
    content: <Notification
      notificationTitle={notificationItem?.title}
      notificationText={notificationItem?.notificationMsg}
    />,
    variant: 'double',
    onClose: () => {
      setNotificationItem(null);
      setIsNotificationModalOpen && setIsNotificationModalOpen(false);
    }
  });

  return <>
    <HeaderNotification 
      hasTopBar={hasTopBar}
      isSearchActive={isSearchActive}
      isImpersonating={isImpersonating}
      isMaintenanceActive={isMaintenanceActive}
      onSelectNotificationItem={onSelectNotificationItem}
    />
  </>;
};

export default HeaderNotificationMenuWrapper;
